import Receipt from './Receipt.jsx';

export default Receipt;